import Box from "../primitives/box";

/**
 * @deprecated Use noted components package instead.
 */
export const TableBody = Box.withComponent("tbody");

TableBody.displayName = "TableBody";

export default TableBody;
